
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Banner07 from "../../components/banner/Banner07";
import Job03 from "../../components/jobs/Job03";
import Category07 from "../../components/category/Category07";
import EmpSec5 from "../../components/employer/EmpSec5";
import Employer from "../../components/employer";
import Job05 from "../../components/jobs/Job05";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import dataCate from "../../assets/fakeData/dataCategory";
import dataJobs from "../../assets/fakeData/dataJobs";
import dataEm from "../../assets/fakeData/dataEmployers";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import Testimonials from "../../components/testimonials";
import Partner from "../../components/partner";
import dataTestimonials from "../../assets/fakeData/dataTestimonials";
import dataPartner from "../../assets/fakeData/dataPartner";
import TopInstitute from "../TopInstitute/TopInstitute"
import Banner01 from "../../components/banner/Banner01";
import Category from "../../components/category";
import Couter from "../../components/iconbox/Couter";
import { Helmet } from "react-helmet";
import Box07 from "../../components/boxicon/Box07";
import ReviewJob10 from "../../components/jobs/ReviewJob10";
// import Banner01 from "../../components/banner/Banner01";

NonLoginHome.propTypes = {};

function NonLoginHome(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <Helmet>
                <title>Home | Jobkikhoj</title>
                <meta name="description" content=" " />
                <meta name="keywords" content=" " />
                <meta property="og:title" content="Home | Jobkikhoj " />
                <meta property="og:description" content="" />
                <meta property="og:url" content="https://jobkikhoj.com" />
            </Helmet>
            <MobileHeader handleMobile={handleMobile} />
            <NonLoginHeader clname="act1" handleMobile={handleMobile} />
            
            <div className="pt-70"> 
            <Banner01 />
            {/* <Category data={dataCate} title= "Browse by category"  text= "Recruitment Made Easy in 100 seconds"/> */}
            <Box07 />
            <ReviewJob10 className="web"/>
            <div className="container">
            <Couter className="background1" />
            </div>
            <Job05 data={dataJobs} />

            <Employer data={dataEm} className="employer-section-two" />
           
            <TopInstitute data={dataEm} className=" " /> 
            <Partner data={dataPartner} /> 
            <Footer />
            <Gotop />
            </div>
        </>
    );
}

export default NonLoginHome;
